<template>
  <div
    class="glide__bullets flex justify-center space-x-1.5"
    data-glide-el="controls[nav]"
  >
    <button
      v-for="i in numberOfSlides"
      :key="i"
      class="glide__bullet flex h-3 w-3 items-center justify-center border-0 bg-transparent p-0"
      :data-glide-dir="`=${i - 1}`"
      :aria-current="isActive(i - 1)"
    >
      <slot v-bind="{ index: i - 1 }">
        <span class="free-carousel__bullet-dot"></span>
      </slot>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { inject } from 'vue';

  import { freeCarouselConfig } from '../config';

  const glider = inject(freeCarouselConfig.gliderInjectionKey);
  const numberOfSlides =
    inject(freeCarouselConfig.numberOfSlidesInjectionKey) || 0;
  const isActive = (idx: number) => idx === glider?.index;
</script>

<style scoped>
  .free-carousel__bullet-dot {
    @apply h-2 w-2 rounded-full;
    background-color: var(
      --free-carousel-bg-color,
      theme('colors.situational.muted')
    );
    transition: 0.2s;
  }

  .glide__bullet--active .free-carousel__bullet-dot {
    background-color: var(
      --free-carousel-active-bullet-color,
      theme('colors.situational.dark')
    );
  }
</style>
